import {MasterUseInstructionModel} from './master-use-instruction.model';
import {MasterInputInstructionModel, MasterOutputInstructionModel} from './master-input-instruction.model';
import {Exclude, Transform, Type} from 'class-transformer';
import {IdCodeNameModel} from 'common-shared';
import {TaskSelectorModel} from "./task-selector.model";
import {ExpressionModel} from "../../common/expression.model";
import {PropertyMappingModel} from "../../properties/models/property-mapping.model";
import {SpecLineModel} from "../../properties/models/spec-line.model";

export class MasterOperationModel extends IdCodeNameModel {
  constructor(init?: Partial<MasterOperationModel>) {
    super();
    Object.assign(this, init);
  }
  SourceCode?: string;

  ProcessSelectorId: string;
  ProcessNumber: number = 0;
  ProcessId: string;
  ProductionOrderId?: any;
  ItemId: string;
  ItemGroupId?: any;
  ParentId: string;
  ParentProcessValidCondition?: string;
  ValidCondition: ExpressionModel = new ExpressionModel();
  ParentValidCondition?: string;
  @Type(() => MasterInputInstructionModel)
  MasterInputInstructions: MasterInputInstructionModel[] = [];
  @Type(() => MasterUseInstructionModel)
  MasterUseInstructions: MasterUseInstructionModel[] = [];
  @Type(() => MasterOutputInstructionModel)
  MasterOutputInstructions: MasterOutputInstructionModel[] = [];
  @Exclude({ toPlainOnly: true })
  $InheritedOperationPropertyMappings: PropertyMappingModel[];
  @Type(() => PropertyMappingModel)
  OperationItemProperties: PropertyMappingModel[] = [];

  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  Id: string;

  @Type(() => TaskSelectorModel)
  TaskSelectors: TaskSelectorModel[] = [];
  @Exclude()
  RowGroupKey: string = '-';

  getLastOutputInstruction() {
    if (this.MasterOutputInstructions.length === 0) {
      return null;
    }
    return this.MasterOutputInstructions[this.MasterOutputInstructions.length - 1];
  }

  getLastInputInstruction() {
    if (this.MasterInputInstructions.length === 0) {
      return null;
    }
    return this.MasterInputInstructions[this.MasterInputInstructions.length - 1];
  }

  getLastUseInstruction() {
    if (this.MasterUseInstructions.length === 0) {
      return null;
    }
    return this.MasterUseInstructions[this.MasterUseInstructions.length - 1];
  }
}



